{
	"title": "Geo Nerd - Connais-tu TOUS les pays du monde ?",
	"description": "Connais-tu les pays du monde, les capitales, les drapeaux ? On va voir ça !",
	"home": {
		"title": "Connais-tu le monde ?",
		"subtitle": "Geo Nerd",
		"intro": "Que tu sois fan de drapeaux, de capitales ou de cartes, il y a un mode fait pour toi.",
		"flagNerd": "Flag Nerd",
		"flagNerdSubtitle": "Pro des drapeaux ?",
		"capitalNerd": "Capital Nerd",
		"capitalNerdSubtitle": "Pro des capitales ?",
		"countryNerd": "Country Nerd",
		"countryNerdSubtitle": "Connais-tu tous les pays du monde ?",
		"mapNerd": "Map Nerd",
		"mapNerdSubtitle": "Pro des pays ?",
		"usStates": "US States",
		"usStatesSubtitle": "Pro des États américains ?",
		"dailyChallenge": "Défi du jour",
		"dailyChallengeSubtitle": "20 questions, un seul essai !",
		"classic": "Classic",
		"hard": "Hard",
		"tricky": "Tricky",
		"speedRun": "Speed Run",
		"reverse": "Inverse",
		"list": "Liste",
		"betaTag": "Bêta",
		"go": "GO",
		"resumeTitle": "Ta partie en cours",
		"reviewDue": "{n} erreurs à réviser aujourd'hui",
		"reviewDueOne": "1 erreur à réviser aujourd'hui",
		"lab": "Le Lab",
		"labSubtitle": "Trois nouveaux jeux à tester, dis-nous ce que tu en penses !",
		"resumeOthersOne": "autre partie en cours",
		"resumeOthers": "autres parties en cours"
	},
	"menu": {
		"home": "Accueil",
		"games": "Jeux",
		"pays": "Pays du jeu",
		"training": "Entraînement",
		"settings": "Sauvegardes",
		"leaderboard": "Classement",
		"aPropos": "À propos",
		"faq": "FAQ",
		"mentionsLegales": "Mentions légales",
		"myProfile": "Mon profil",
		"inProgress": "Parties en cours",
		"news": "Nouveautés",
		"logout": "Se déconnecter",
		"login": "Connexion",
		"register": "S'inscrire",
		"mainNav": "Navigation principale",
		"openMenu": "Ouvrir le menu",
		"accountMenu": "Mon compte",
		"back": "Retour",
		"passport": "Mon passeport",
		"review": "Réviser mes erreurs"
	},
	"settings": {
		"title": "Sauvegardes",
		"all": "Lettres",
		"clearData": "Effacer les données",
		"clearFlagNerdClassic": "Effacer Flag Nerd Classique",
		"clearFlagNerdHard": "Effacer Flag Nerd Difficile",
		"clearFlagNerdTricky": "Effacer Flag Nerd Tricky",
		"clearCapitalNerdClassic": "Effacer Capital Nerd Classique",
		"clearCapitalNerdHard": "Effacer Capital Nerd Difficile",
		"clearCountryNerd": "Effacer Country Nerd",
		"clearMapNerdClassic": "Effacer Map Nerd Classique",
		"clearMapNerdHard": "Effacer Map Nerd Difficile",
		"language": "Langue",
		"reset": "Réinitialiser",
		"confirmTitle": "Confirmation",
		"confirmMessage": "Es-tu sûr de vouloir réinitialiser cette partie ?",
		"clearAllNotice": "Toutes les progressions seront définitivement supprimées.",
		"cancel": "Annuler",
		"confirm": "Confirmer"
	},
	"game": {
		"lives": "Vies",
		"best": "Meilleur",
		"score": "Score",
		"capitalsFound": "Capitales trouvées",
		"countriesFound": "Pays trouvés",
		"countriesLeft": "Pays restants",
		"validate": "OK",
		"tryAgain": "Réessayer",
		"restart": "Recommencer",
		"backHome": "Retour",
		"won": "Bravo !",
		"lost": "Perdu !",
		"backToLetters": "Choisir une autre lettre",
		"replayLetter": "Refaire cette lettre",
		"bestTime": "record",
		"newBestTime": "Nouveau record !",
		"youWon": "Tu as gagné !",
		"youLost": "C'est fini, peux-tu battre ton record ?",
		"whatIsThisFlag": "De quel pays est ce drapeau ?",
		"whatIsThisCapital": "Quelle est la capitale de",
		"whichCountryCapital": "De quel pays est cette capitale ?",
		"doYouKnowAllCapitals": "Connais-tu toutes les capitales ?",
		"doYouKnowAllCountries": "Connais-tu tous les pays du monde ?",
		"countryNerdHelp": "Retrouve tous les pays du monde commençant par chaque lettre de l'alphabet. Une fois une lettre terminée, tu peux passer à la suivante !",
		"countryNerdHardHelp": "Retrouve tous les pays du monde commençant par chaque lettre de l'alphabet. En mode Hard, aucun indice sur le nombre qu'il reste : à toi de tout deviner !",
		"findCountriesStartingWith": "Trouve les pays commençant par :",
		"wellDoneTryAnotherLetter": "Bien joué, on essaie une autre lettre ?",
		"typeCountryName": "Tape le nom du pays",
		"typeCapitalName": "Tape le nom de la capitale",
		"enterCountryStartingWith": "Entre un pays commençant par",
		"infiniteMode": "Mode Infini",
		"continueInfinite": "Continuer en mode Infini",
		"mapWon": "Impressionnant, t’es un vrai&nbsp;<br>pro des pays du monde !",
		"chooseCountry": "Choisis un pays sur la carte",
		"howToPlay": "Comment jouer ?",
		"mapClassicHelp": "Trouve le pays indiqué en cliquant sur la carte.<br>Attention, tu as seulement 3 vies !",
		"mapHardHelp": "Clique sur un pays de la carte puis tape son nom pour le valider. Attention, tu as seulement 3 vies !",
		"dontShowAgain": "Ne plus afficher",
		"letsGo": "C'est parti !",
		"speedRun": "Speed Run",
		"timeRemaining": "Temps restant",
		"timeUp": "Temps écoulé !",
		"newBest": "Nouveau record !",
		"yourMistakes": "Tes erreurs",
		"dailyChallenge": "Défi du jour",
		"alreadyPlayed": "Tu as déjà joué aujourd'hui, reviens demain !",
		"comeBackTomorrow": "Reviens demain pour un nouveau défi !",
		"streak": "Série en cours",
		"streakBest": "Record",
		"backToScopes": "Changer de zone",
		"answerWas": "C'était :",
		"elapsedTime": "Temps",
		"bestScore": "Meilleur score",
		"hint": "Indice",
		"hintConfirmMessage": "Un indice compte comme une erreur de plus au classement. Continuer ?",
		"lettersDone": "lettres",
		"countriesTotal": "pays",
		"ready": "Prêt ?",
		"startRun": "Démarrer le chrono",
		"speedRunStartHelp": "Le chrono part au clic sur « Démarrer » : prends le temps de te préparer.",
		"usStatesWon": "Bien joué, tu connais tous les&nbsp;<br>États américains !",
		"chooseState": "Choisis un État sur la carte",
		"usStatesClassicHelp": "Trouve l'État indiqué en cliquant sur la carte.<br>Attention, tu as seulement 3 vies !",
		"usStatesHardHelp": "Clique sur un État de la carte puis tape son nom pour le valider. Attention, tu as seulement 3 vies !",
		"typeStateName": "Tape le nom de l'État",
		"doYouKnowAllStates": "Connais-tu tous les États américains ?",
		"usStatesListHelp": "Retrouve les 50 États américains en tapant leur nom. Ils se placent dans la liste à leur ordre alphabétique au fur et à mesure.",
		"statesFound": "États trouvés"
	},
	"mapExploration": {
		"pickerTitle": "Choisis ta zone",
		"worldLabel": "Monde",
		"rankedLabel": "Classé",
		"trainingLabel": "Entraînement",
		"title": "Exploration du monde",
		"rankLabel": "Rang",
		"discovered": "pays découverts",
		"focusContinent": "Continent à travailler",
		"ranks": {
			"tourist": "Touriste",
			"explorer": "Explorateur",
			"adventurer": "Aventurier",
			"globetrotter": "Globe-trotteur",
			"master": "Maître du monde"
		},
		"continents": {
			"af": "Afrique",
			"eu": "Europe",
			"as": "Asie & Océanie",
			"am": "Amériques"
		}
	},
	"scores": {
		"noScore": "-",
		"myRecords": "Mes Records",
		"share": "Partager mon score",
		"shareGlobal": "Partager tous mes scores",
		"copied": "Copié !",
		"copyFailed": "Échec de la copie",
		"gamesPlayed": "Parties jouées",
		"averageScore": "Score moyen",
		"progression": "Progression",
		"reset": "Réinitialiser",
		"globalStats": "Statistiques globales",
		"totalGamesPlayed": "Total parties jouées",
		"successRate": "Taux de réussite",
		"bestMode": "Meilleur mode",
		"worstMode": "Mode à travailler"
	},
	"training": {
		"directory": "Annuaire des pays",
		"directorySubtitle": "Drapeaux & Capitales",
		"directoryIntro": "<p>Cet annuaire réunit les <strong>193 États membres de l'Organisation des Nations unies</strong>, avec leur drapeau et leur capitale. Les territoires, dépendances et États non reconnus n'y figurent pas : c'est exactement le même périmètre que les quiz de Geo Nerd, pour que ce que tu révises ici te serve directement en jeu.</p><p>Utilise la barre de recherche pour retrouver un pays par son nom, ou les filtres par continent pour travailler une zone à la fois : <strong>54 pays en Afrique</strong>, <strong>44 en Europe</strong>, <strong>35 dans les Amériques</strong> et <strong>60 en Asie et Océanie</strong>. Les pays sont classés par ordre alphabétique, capitale indiquée sous chaque nom.</p><p>Reconnaître un drapeau, retrouver une capitale et situer un pays sur une carte ne font pas appel à la même mémoire : c'est en alternant les trois qu'on retient durablement. Quand tu te sens prêt, va te tester.</p>",
		"directoryScope": "Les 193 États membres de l'ONU : les territoires, dépendances et États non reconnus n'apparaissent pas dans le jeu.",
		"directoryPlay": "Passe aux quiz :",
		"worldMap": "Carte du monde",
		"worldMapSubtitle": "Exploration interactive",
		"usStatesMap": "Carte des États-Unis",
		"mapOk": "OK",
		"search": "Rechercher un pays...",
		"allContinents": "Tous",
		"tooltipMore": "En savoir plus"
	},
	"leaderboard": {
		"title": "Classement",
		"subtitle": "Les meilleurs joueurs du monde",
		"rank": "Rang",
		"player": "Joueur",
		"score": "Score",
		"errors": "Erreurs",
		"lives": "Vies",
		"viewLeaderboard": "Voir le classement",
		"time": "Temps",
		"empty": "Aucun score enregistré pour ce mode pour l'instant.",
		"loading": "Chargement…",
		"errorLoad": "Impossible de charger le classement.",
		"currentStreak": "Série en cours",
		"exploration": "Exploration",
		"composite": "Score global",
		"global": "Global",
		"compositeExplanation": "Ce score réunit tous les modes de jeu en une seule note sur 1000 : chaque meilleur score y compte pour sa part, les versions Hard comptant double.",
		"avgScore": "Moy.",
		"countriesFound": "Pays trouvés",
		"livesLeft": "{n} vies restantes",
		"legacyInfoLabel": "À propos de ce score",
		"legacyScoreNote": "Les scores affichés sans vies ni temps ont été réalisés avant que Geo Nerd n’enregistre le temps et les erreurs. Ils sont conservés tels quels, mais classés après les scores mesurés à égalité de points. Geo Nerd est en cours de développement, encore en phase bêta : merci de votre patience !",
		"today": "aujourd’hui",
		"yesterday": "hier",
		"daysAgo": "il y a {n} j",
		"monthsAgo": "il y a {n} mois",
		"yourPosition": "Ton classement : {rank}/{total}",
		"notRankedYet": "Tu n’as pas encore de score dans ce mode.",
		"gapToNext": "+{n} pour dépasser {player}",
		"gapTiebreak": "À égalité avec {player} : il te faut moins de fautes ou un meilleur temps",
		"findMe": "Me situer",
		"playCta": "Jouer à ce mode",
		"resumeLabel": "Tu as une partie en cours dans ce mode",
		"you": "Toi",
		"profileEmpty": "Ce joueur n’a pas encore de score enregistré.",
		"profileMemberSince": "Membre depuis le {date}",
		"profileGamesPlayed": "{n} parties jouées",
		"dailyMedalsTitle": "Palmarès",
		"periodAll": "Depuis toujours",
		"periodWeek": "Cette semaine",
		"weekEndsDays": "Remise à zéro dans {d} j {h} h (lundi, minuit UTC)",
		"weekEndsHours": "Remise à zéro dans {h} h (lundi, minuit UTC)",
		"emptyWeek": "Personne n'a encore joué ce mode cette semaine : la première place est à prendre !"
	},
	"country": {
		"breadcrumbHome": "Accueil",
		"breadcrumbCountries": "Pays du monde",
		"h1": "{name} : drapeau, capitale et carte",
		"metaTitle": "{name} : drapeau et signification, capitale, carte",
		"metaDescription": "{name} : la signification de son drapeau, sa capitale {capital}, sa population et sa carte. Puis un quiz pour reconnaître les 193 drapeaux du monde.",
		"intro": "{name} en un coup d’œil : son drapeau, sa capitale {capital}, sa population et sa position sur la carte du monde. De quoi se tester ensuite.",
		"flagTitle": "{name} : le drapeau et sa signification",
		"flagAlt": "Drapeau : {name}",
		"mapTitle": "{name} sur la carte du monde",
		"mapAlt": "Carte de localisation : {name}",
		"exploreMap": "Explorer sur la carte du monde",
		"factsTitle": "{name} en chiffres",
		"capital": "Capitale",
		"population": "Population",
		"area": "Superficie",
		"currency": "Monnaie",
		"language": "Langue officielle",
		"languages": "Langues officielles",
		"demonym": "Gentilé",
		"nativeName": "Nom local",
		"officialName": "Nom officiel",
		"tld": "Domaine internet",
		"phone": "Indicatif téléphonique",
		"continent": "Continent",
		"unMember": "Membre de l'ONU depuis",
		"bordersTitle": "{name} : pays frontaliers",
		"bordersCount": "{count} pays frontaliers",
		"bordersOne": "Un seul pays frontalier",
		"bordersNone": "Aucune frontière terrestre.",
		"related": {
			"AF": "D'autres pays d'Afrique",
			"EU": "D'autres pays d'Europe",
			"AS": "D'autres pays d'Asie et d'Océanie",
			"AM": "D'autres pays des Amériques"
		},
		"playTitle": "Tester ses connaissances",
		"playIntro": "Ce pays est désormais familier : les 192 autres méritent aussi d'être découverts.",
		"playFlag": "Reconnaître les drapeaux",
		"playCapital": "Deviner les capitales",
		"playMap": "Situer les pays sur la carte",
		"playDirectory": "Revoir tous les pays",
		"inhabitants": "habitants",
		"populationMillion": "{n} million d’habitants",
		"populationMillions": "{n} millions d’habitants",
		"populationBillion": "{n} milliard d’habitants",
		"populationBillions": "{n} milliards d’habitants",
		"populationAsOf": "en {year}",
		"source": "Données : Wikidata (CC0). Drapeaux et carte : Geo Nerd.",
		"sourceOsm": "Données : Wikidata (CC0). Drapeau : Geo Nerd. Contour de la carte : © contributeurs OpenStreetMap (ODbL).",
		"sourceCcBy": "Données : Wikidata (CC0). Drapeau : Geo Nerd. Contour de la carte : geoBoundaries, Wikimedia Commons (CC BY 2.5)."
	},
	"pages": {
		"404": {
			"title": "Page introuvable - Geo Nerd",
			"description": "Oups, cette page n'existe pas ou a été déplacée."
		},
		"leaderboard": {
			"title": "Classement mondial - Geo Nerd",
			"description": "Le classement des meilleurs joueurs de Geo Nerd dans le monde, mode par mode : drapeaux, capitales, carte et défi du jour."
		},
		"home": {
			"title": "Geo Nerd - Connais-tu TOUS les pays du monde ?",
			"description": "Teste tes connaissances sur les pays, capitales et drapeaux du monde entier ! Es-tu un vrai Geo Nerd ?"
		},
		"pays": {
			"title": "Annuaire des Pays - Geo Nerd",
			"description": "Toutes les infos sur tous les pays : drapeaux, noms originaux et capitales."
		},
		"trainingMap": {
			"title": "Carte Interactive - Geo Nerd",
			"description": "Explore la carte du monde librement et clique sur les pays pour découvrir leur nom, drapeau et capitale."
		},
		"trainingMapUs": {
			"title": "Carte des États-Unis Interactive - Geo Nerd",
			"description": "Explore librement la carte des États-Unis et clique sur un État pour découvrir son nom et son drapeau."
		},
		"aPropos": {
			"title": "À propos - Geo Nerd",
			"description": "Geo Nerd, c'est quoi ? Un quiz de géographie gratuit sur les pays, drapeaux et capitales du monde, sans compte obligatoire."
		},
		"faq": {
			"title": "FAQ - Geo Nerd",
			"description": "Les réponses aux questions les plus fréquentes sur Geo Nerd : scores, compte, données, langues disponibles."
		},
		"mentionsLegales": {
			"title": "Mentions légales - Geo Nerd",
			"description": "Mentions légales et politique de confidentialité de Geo Nerd : éditeur, hébergeur, données collectées."
		},
		"flagNerdClassic": {
			"title": "Flag Nerd Classique - Devine le Drapeau - Geo Nerd",
			"description": "Devine le pays correspondant au drapeau affiché. Un classique pour apprendre en s'amusant !"
		},
		"flagNerdHard": {
			"title": "Flag Nerd Expert - Défi Difficile - Geo Nerd",
			"description": "Mode expert pour les champions des drapeaux. Aucune aide, juste ton talent !"
		},
		"flagNerdTricky": {
			"title": "Flag Nerd Tricky - Drapeaux Pièges - Geo Nerd",
			"description": "Des propositions volontairement trompeuses entre drapeaux qui se ressemblent. Ne te fais pas avoir !"
		},
		"flagNerdSpeedRun": {
			"title": "Flag Nerd Speed Run - Geo Nerd",
			"description": "Combien de drapeaux peux-tu identifier en 60 secondes ? Challenge tes réflexes !"
		},
		"capitalNerdClassic": {
			"title": "Capital Nerd - Les Capitales du Monde - Geo Nerd",
			"description": "Es-tu incollable sur les capitales ? Teste-toi sur tous les pays du monde !"
		},
		"capitalNerdHard": {
			"title": "Capital Nerd Expert - La capitale du drapeau - Geo Nerd",
			"description": "Retrouve la capitale à partir du seul drapeau, parmi 4 propositions. Pas de nom de pays affiché !"
		},
		"capitalNerdSpeedRun": {
			"title": "Capital Nerd Speed Run - Geo Nerd",
			"description": "Vitesse et précision : trouve un maximum de capitales avant la fin du chrono !"
		},
		"capitalNerdReverse": {
			"title": "Capital Nerd Inverse - De quel pays est cette capitale ? - Geo Nerd",
			"description": "Le défi des capitales à l'envers : on te donne une capitale, retrouve le pays parmi 4 propositions !"
		},
		"countryNerd": {
			"title": "Country Nerd - L'ABC des pays - Geo Nerd",
			"description": "Trouve tous les pays du monde commençant par chaque lettre de l'alphabet. Incollable ?"
		},
		"countryNerdHard": {
			"title": "Country Nerd Hard - L'ABC des pays sans filet - Geo Nerd",
			"description": "Trouve tous les pays du monde commençant par chaque lettre, sans aucun indice sur ceux qui restent. Le défi ultime !"
		},
		"mapNerdClassic": {
			"title": "Map Nerd Classique - Où se trouve ce pays ? - Geo Nerd",
			"description": "On te donne un nom, à toi de trouver le pays sur la carte du monde ! Éviter les erreurs sinon c'est perdu."
		},
		"mapNerdHard": {
			"title": "Map Nerd Expert - Nomme le pays - Geo Nerd",
			"description": "Clique sur un pays de la carte et écris son nom correctement. Le défi géographique ultime."
		},
		"usStatesClassic": {
			"title": "US States Classique - Où se trouve cet État ? - Geo Nerd",
			"description": "On te donne le nom d'un État américain (et son drapeau), à toi de le trouver sur la carte des USA ! Évite les erreurs sinon c'est perdu."
		},
		"usStatesHard": {
			"title": "US States Expert - Nomme l'État - Geo Nerd",
			"description": "Clique sur un État de la carte des USA et écris son nom correctement. Le défi géographique ultime."
		},
		"usStatesList": {
			"title": "US States Liste - Les 50 États américains - Geo Nerd",
			"description": "Retrouve les 50 États américains en tapant leur nom, sans carte ni chrono imposé. Combien en connais-tu ?"
		},
		"dailyChallenge": {
			"title": "Défi du jour - Geo Nerd",
			"description": "20 questions de plus en plus difficiles, drapeaux ou capitales selon le jour, un seul essai par jour. Compare ton score avec tes amis !"
		},
		"dailyChallengeHard": {
			"title": "Défi du jour Expert - Geo Nerd",
			"description": "20 questions sans aucune proposition, drapeaux ou capitales selon le jour, un seul essai par jour. Le mode ultime !"
		},
		"resetPassword": {
			"title": "Réinitialiser le mot de passe - Geo Nerd",
			"description": "Définis un nouveau mot de passe pour accéder à ton compte Geo Nerd."
		},
		"geoadmin": {
			"title": "Admin - Geo Nerd",
			"description": "Administration Geo Nerd."
		},
		"avatar": {
			"title": "Mon avatar - Geo Nerd",
			"description": "Personnalise ton avatar Geo Nerd : sourcils, yeux, lunettes, bouche, nez et couleur."
		},
		"profil": {
			"title": "Mon profil - Geo Nerd",
			"description": "Ton avatar, ton pseudo et ta progression sur tous les modes de jeu Geo Nerd."
		},
		"partiesEnCours": {
			"title": "Parties en cours - Geo Nerd",
			"description": "Reprends tes parties Geo Nerd non terminées ou abandonne-les pour repartir de zéro."
		},
		"connexion": {
			"title": "Connexion - Geo Nerd",
			"description": "Connecte-toi pour retrouver tes scores Geo Nerd sur tous tes appareils."
		},
		"inscription": {
			"title": "Inscription - Geo Nerd",
			"description": "Crée ton compte Geo Nerd pour sauvegarder tes scores et entrer au classement mondial."
		},
		"motDePasseOublie": {
			"title": "Mot de passe oublié - Geo Nerd",
			"description": "Reçois un lien pour choisir un nouveau mot de passe Geo Nerd."
		},
		"desinscription": {
			"title": "Désinscription des rappels - Geo Nerd",
			"description": "Ne plus recevoir les rappels du Défi du jour de Geo Nerd."
		},
		"passeport": {
			"title": "Mon passeport - Geo Nerd",
			"description": "Tes tampons de drapeaux, de capitales et de carte, pays par pays."
		},
		"revision": {
			"title": "Révision de mes erreurs - Geo Nerd",
			"description": "Les drapeaux et capitales ratés reviennent au bon moment, jusqu'à ce qu'ils soient acquis."
		},
		"friendChallenge": {
			"title": "Défi un ami : quiz de géographie à partager - Geo Nerd",
			"description": "10 questions de géographie, un lien à envoyer : ton ami joue les mêmes questions et vous comparez vos scores."
		},
		"borderNerd": {
			"title": "Border Nerd : les pays voisins - Geo Nerd",
			"description": "Cite tous les pays frontaliers de chaque pays. Combien en connais-tu ?"
		},
		"shapeNerd": {
			"title": "Shape Nerd : reconnaître les pays à leur forme - Geo Nerd",
			"description": "Reconnais les pays du monde à leur silhouette, parmi des pays du même continent."
		},
		"shapeNerdHard": {
			"title": "Shape Nerd Hard : nommer les pays à leur forme - Geo Nerd",
			"description": "Reconnais les pays du monde à leur silhouette et tape leur nom, sans propositions pour t'aider."
		}
	},
	"notFound": {
		"title": "Page introuvable",
		"description": "Cette page n'existe pas ou a été déplacée.",
		"cta": "Retour à l'accueil"
	},
	"errors": {
		"dataLoad": "Impossible de charger les données des pays. Vérifie ta connexion et recharge la page."
	},
	"account": {
		"title": "Mon compte",
		"intro": "Crée un compte pour sauvegarder tes scores en ligne et les retrouver sur tous tes appareils.",
		"login": "Connexion",
		"register": "Inscription",
		"usernamePlaceholder": "Pseudo (3-20 caractères : lettres, chiffres, _ ou -)",
		"emailPlaceholder": "Email",
		"passwordPlaceholder": "Mot de passe",
		"newPasswordPlaceholder": "Mot de passe (8 caractères min.)",
		"loginCta": "Se connecter",
		"registerCta": "Créer mon compte",
		"forgotLink": "Mot de passe oublié ?",
		"forgotIntro": "Saisis ton email : nous t'enverrons un lien pour choisir un nouveau mot de passe.",
		"forgotCta": "Envoyer le lien",
		"forgotSent": "Si un compte existe pour cet email, un lien de réinitialisation vient d'être envoyé.",
		"backToLogin": "Retour à la connexion",
		"connectedAs": "Connecté",
		"editField": "Modifier",
		"saveProfile": "Enregistrer",
		"profileUpdated": "Tes informations ont été mises à jour.",
		"synced": "Tes scores sont sauvegardés en ligne et synchronisés sur tous tes appareils.",
		"logout": "Se déconnecter",
		"errors": {
			"network": "Connexion au serveur impossible. Réessaie plus tard.",
			"tooMany": "Trop de tentatives. Réessaie dans quelques minutes.",
			"alreadyRegistered": "Cet email ou ce pseudo est déjà utilisé.",
			"invalidCredentials": "Email ou mot de passe incorrect.",
			"invalidInput": "Vérifie l'email et le mot de passe (8 caractères min.).",
			"invalidEmail": "Vérifie l'adresse email saisie.",
			"invalidPassword": "Mot de passe invalide : il doit contenir entre 8 et 200 caractères.",
			"emailTaken": "Cet email est déjà utilisé par un autre compte.",
			"usernameTaken": "Ce pseudo est déjà utilisé.",
			"generic": "Une erreur est survenue. Réessaie."
		},
		"reset": {
			"title": "Nouveau mot de passe",
			"intro": "Choisis un nouveau mot de passe pour ton compte Geo Nerd.",
			"cta": "Valider",
			"backHome": "Retour à l'accueil",
			"goLogin": "Se connecter",
			"success": "Mot de passe mis à jour ! Tu peux maintenant te connecter.",
			"invalidToken": "Ce lien est invalide ou a expiré. Refais une demande de réinitialisation.",
			"missingToken": "Lien invalide : aucun jeton de réinitialisation. Refais une demande depuis la connexion."
		},
		"editAvatar": "Modifier mon avatar",
		"loginIntro": "Connecte-toi pour retrouver tes scores et ton classement sur tous tes appareils.",
		"noAccount": "Pas encore de compte ?",
		"haveAccount": "Tu as déjà un compte ?",
		"goRegister": "Créer un compte",
		"goLogin": "Se connecter",
		"forgotTitle": "Mot de passe oublié",
		"reminderOptIn": "M'envoyer un rappel par e-mail les jours où je n'ai pas encore joué le Défi du jour (désinscription en un clic).",
		"newsNotice": "Ton e-mail sert aussi à t'annoncer les nouveautés du jeu, quelques fois par an au plus. Tu peux t'y opposer depuis ton profil ou en un clic depuis chaque e-mail."
	},
	"notifications": {
		"title": "Nouveautés"
	},
	"profile": {
		"title": "Mon profil",
		"subtitle": "Ton avatar, ton pseudo et ta progression.",
		"progressTitle": "Ma progression",
		"anonymousTitle": "Tu joues sans compte",
		"anonymousIntro": "Ta progression est enregistrée sur cet appareil uniquement. Crée un compte pour la retrouver partout et entrer au classement mondial.",
		"anonymousName": "Joueur anonyme",
		"noUsername": "Sans pseudo"
	},
	"inProgress": {
		"title": "Parties en cours",
		"subtitle": "Reprends une partie là où tu l'as laissée, ou abandonne-la pour repartir de zéro.",
		"empty": "Aucune partie en cours. Lance un mode de jeu : il apparaîtra ici tant qu'il ne sera pas terminé.",
		"emptyCta": "Voir tous les jeux",
		"resume": "Reprendre",
		"abandon": "Abandonner",
		"abandonTitle": "Abandonner cette partie ?",
		"abandonMessage": "La progression de cette partie sera perdue. Ton meilleur score, lui, est conservé.",
		"progressLabel": "Progression",
		"livesLabel": "Vies restantes",
		"startedLabel": "Commencée",
		"elapsedLabel": "Temps écoulé",
		"letterLabel": "Lettre {letter}",
		"questionLabel": "Question {n}/{total}",
		"dailyLocked": "Le défi du jour ne s'abandonne pas : il n'y a qu'un essai par jour, pour tout le monde.",
		"today": "aujourd'hui",
		"yesterday": "hier",
		"daysAgo": "il y a {n} jours"
	},
	"avatar": {
		"title": "Mon avatar",
		"subtitle": "Personnalise ton avatar",
		"random": "Aléatoire",
		"reset": "Par défaut",
		"confirm": "Valider",
		"color": "Couleur",
		"brows": "Sourcils",
		"eyes": "Yeux",
		"glasses": "Lunettes",
		"mouth": "Bouche",
		"nose": "Nez",
		"syncNote": "Connecte-toi pour sauvegarder ton avatar sur tous tes appareils.",
		"saving": "Enregistrement…",
		"saved": "Avatar enregistré sur cet appareil !",
		"savedSynced": "Avatar enregistré",
		"saveError": "Avatar enregistré sur cet appareil, mais la synchronisation a échoué."
	},
	"about": {
		"kicker": "Le projet",
		"h1": "À propos de Geo Nerd",
		"lead": "Geo Nerd teste ce qu'on sait vraiment des pays du monde : leur drapeau, leur capitale, leur position sur la carte. Pas de vulgarisation ni de quiz à rallonge, juste la question posée directement, avec un chrono qui ne pardonne pas dans les modes difficiles.",
		"statCountriesLabel": "États membres de l'ONU",
		"statModesLabel": "modes de jeu répartis en 7 familles",
		"statMapLabel": "pays à placer sur la carte du monde",
		"statsNote": "Gratuit, sans publicité, sans inscription obligatoire.",
		"modesTitle": "Les sept familles de jeux",
		"modesIntro": "Chaque famille a ses variantes : le QCM pour apprendre, la saisie au clavier pour vérifier, le chrono pour se faire mal.",
		"modeDailyBody": "20 questions, les mêmes pour tout le monde, un seul essai par jour. Le résultat se partage en grille d'emojis, la série en cours s'affiche au classement avec des flammes, et le palmarès or/argent/bronze est visible sur le profil.",
		"modeDailyClassicDesc": "20 questions à choix multiples, un essai par jour.",
		"modeDailyHardDesc": "Le même défi, sans les 4 propositions à cliquer.",
		"modeFlagBody": "Un drapeau s'affiche, le pays est à trouver. En QCM, au clavier, contre la montre, ou en version piégeuse.",
		"modeFlagClassicDesc": "Un drapeau affiché, le pays à trouver parmi 4 choix.",
		"modeFlagHardDesc": "Le pays à taper au clavier, sans proposition.",
		"modeFlagSpeedRunDesc": "60 secondes chrono, un maximum de bonnes réponses.",
		"modeFlagTrickyDesc": "Des drapeaux qui se ressemblent vraiment, pour experts.",
		"modeCapitalBody": "La capitale d'un pays, le pays d'une capitale, ou la capitale cachée derrière un simple drapeau.",
		"modeCapitalClassicDesc": "Un pays affiché, sa capitale à trouver parmi 4 choix.",
		"modeCapitalHardDesc": "Un drapeau seul, sans le nom du pays.",
		"modeCapitalSpeedRunDesc": "Le mode Classic, en 60 secondes chrono.",
		"modeCapitalReverseDesc": "Une capitale affichée, le pays à retrouver.",
		"modeMapBody": "Un nom de pays s'affiche, il faut cliquer au bon endroit sur la carte du monde. 170 pays jouables.",
		"modeMapClassicDesc": "Clique sur le pays demandé, sur la carte du monde.",
		"modeMapHardDesc": "Clique sur la carte, puis tape le nom du pays.",
		"modeCountryBody": "Le mode le plus long : les 193 pays à retrouver de mémoire, lettre par lettre, de A à Z.",
		"modeCountryClassicDesc": "Tous les pays à trouver, lettre par lettre.",
		"modeCountryHardDesc": "Le même défi, sans indice sur le nombre restant.",
		"modeUsStatesBody": "Les 50 États américains, à situer sur la carte ou à retrouver de mémoire.",
		"modeUsStatesClassicDesc": "Trouve l'État indiqué en cliquant sur la carte.",
		"modeUsStatesHardDesc": "Clique sur un État, puis tape son nom.",
		"modeUsStatesListDesc": "Retrouve les 50 États en tapant leur nom.",
		"howTitle": "Comment ça marche",
		"howNoAccountTitle": "Jouable sans inscription",
		"howNoAccountBody": "La progression et les meilleurs scores restent dans le navigateur, même sans créer de compte.",
		"howAccountTitle": "Un compte pour retrouver sa progression",
		"howAccountBody": "Les scores se synchronisent d'un appareil à l'autre et entrent au classement mondial, si ça te tente.",
		"howFreeTitle": "Gratuit, sans publicité",
		"howFreeBody": "Pas de bannière, pas de vidéo à regarder, pas de version payante qui débloquerait des pays.",
		"howBilingualTitle": "Deux langues, un seul site",
		"howBilingualBody": "Tout existe en français et en anglais, y compris les noms de pays et de capitales.",
		"projectTitle": "Les coulisses",
		"projectBody": "<p>Geo Nerd part des 193 États membres de l'ONU, pas un de plus ni de moins : ni les territoires, ni les dépendances, ni les États non reconnus, pour garder un périmètre complet et identique d'un jeu à l'autre.</p><p>Le Défi du jour tire les mêmes questions pour tout le monde à partir de la date, un peu comme un Wordle, et quand un drapeau change dans la vraie vie, comme celui de la Syrie fin 2024, il change ici aussi.</p><p>Le site est fait par une seule personne, sur son temps libre, sans studio ni régie publicitaire derrière. Pas de framework, pas de compte obligatoire : juste assez de code pour que ça marche.</p>",
		"contactTitle": "Une remarque, un bug, un drapeau qui semble faux ?",
		"contactBody": "Un message suffit, tout retour est lu.",
		"supportTitle": "Soutenir le projet",
		"supportBody": "Le site est gratuit et le restera. Un don, quel qu'il soit, aide à payer l'hébergement.",
		"supportCta": "Soutenir Geo Nerd",
		"faqCta": "D'autres questions ? La FAQ répond aux plus fréquentes.",
		"faqLink": "Lire la FAQ",
		"ctaTitle": "À toi de jouer",
		"ctaBody": "Pas d'inscription pour commencer, juste un premier drapeau à reconnaître.",
		"ctaPlay": "Jouer",
		"ctaLeaderboard": "Voir le classement",
		"modeLabBody": "Trois nouveaux jeux en bêta, pour varier les plaisirs et aller plus loin que les drapeaux et les capitales."
	},
	"howToPlay": {
		"h1": "Comment jouer ?",
		"flagNerdClassic": "Un drapeau est affiché, le pays correspondant est à trouver parmi 4 propositions.",
		"flagNerdClassicTip": "Idéal pour découvrir tous les drapeaux du monde sans pression : les 4 propositions permettent d'apprendre par élimination.",
		"flagNerdHard": "Même principe, mais sans les 4 propositions à cliquer : il faut taper le nom du pays au clavier (les fautes de frappe raisonnables sont tolérées).",
		"flagNerdHardTip": "Sans proposition à cliquer, il faut vraiment connaître le pays, pas seulement reconnaître son drapeau parmi d'autres.",
		"flagNerdTricky": "Les 4 propositions sont volontairement piégeuses : des drapeaux qui se ressemblent vraiment. Le mode pour ceux qui pensent tout savoir.",
		"flagNerdTrickyTip": "De quoi ne plus jamais confondre l'Indonésie et Monaco, ou le Tchad et la Roumanie. Ce mode est encore en bêta : ses scores n'entrent pas au classement.",
		"flagNerdSpeedRun": "60 secondes, un maximum de bonnes réponses. Chaque erreur retire 2 secondes au chrono.",
		"flagNerdSpeedRunTip": "Le classement retient ton meilleur score : à toi de le battre à chaque partie.",
		"capitalNerdClassic": "Un pays est affiché, sa capitale est à trouver parmi 4 propositions.",
		"capitalNerdHard": "Seul un drapeau est affiché, sans le nom du pays : la capitale correspondante est à trouver parmi 4 propositions.",
		"capitalNerdHardTip": "Il faut d'abord reconnaître le pays au drapeau, puis se souvenir de sa capitale : un vrai double défi.",
		"capitalNerdSpeedRun": "Le principe de Capital Nerd Classique, en 60 secondes chrono.",
		"capitalNerdSpeedRunTip": "Autant de précision que de vitesse : mieux vaut parfois passer une question que se tromper.",
		"capitalNerdReverse": "Le mode inversé : une capitale est affichée, le pays correspondant est à retrouver parmi 4 propositions.",
		"capitalNerdReverseTip": "Un bon test pour vérifier que tu connais vraiment les capitales, pas seulement les pays.",
		"countryNerd": "Tous les pays du monde sont à retrouver, lettre par lettre : le nombre de pays restants est indiqué pour chaque lettre.",
		"countryNerdTip": "Le compteur affiché sur chaque lettre indique combien de pays il reste à trouver, jamais lesquels.",
		"countryNerdHard": "Le même défi, sans aucun indice sur le nombre de pays restants par lettre.",
		"countryNerdHardTip": "Sans indice sur le nombre de pays restants, il faut vraiment connaître l'alphabet des pays par cœur.",
		"usStatesList": "Les 50 États américains sont à retrouver en tapant leur nom : ils se placent dans la liste à leur ordre alphabétique au fur et à mesure.",
		"trainingMapTitle": "Entraînement",
		"trainingMap": "Clique sur n'importe quel pays pour découvrir son nom, son drapeau et sa capitale, sans chrono ni vies.",
		"trainingMapTip": "Idéal pour réviser avant de tenter les modes chronométrés ou à vies de Map Nerd.",
		"trainingMapUs": "Clique sur n'importe quel État américain pour découvrir son nom et son drapeau, sans chrono ni vies.",
		"trainingMapUsTip": "Idéal pour réviser avant de tenter les modes chronométrés ou à vies de US States.",
		"dailyChallenge": "20 questions de plus en plus difficiles, les mêmes pour tout le monde : drapeaux le lundi, le mercredi, le vendredi et le dimanche, capitales le mardi et le jeudi, les deux le samedi. Un seul essai par jour, et le résultat se compare entre amis grâce à la grille partageable.",
		"dailyChallengeHard": "Le Défi du jour sans les 4 propositions : il faut taper le nom du pays, ou celui de la capitale les jours de capitales.",
		"dailyChallengeHardTip": "Le même défi que la version classique, mais sans aucune proposition : 20 questions à résoudre de mémoire.",
		"labBeta": "Ce mode est en bêta : il ne compte pas encore au classement, et tes retours sont les bienvenus.",
		"friendChallenge": "Choisis un thème et réponds à 10 questions de plus en plus difficiles. Envoie ensuite le lien : ton ami joue exactement les mêmes questions et découvre qui a gagné.",
		"borderNerd": "Un pays s'affiche : tape le nom de tous ses voisins. Un pays qui n'est pas un voisin coûte une vie, tout comme « Je passe », qui dévoile ceux qui manquent.",
		"shapeNerd": "Reconnais chaque pays à sa silhouette parmi quatre pays du même continent. Trois erreurs et c'est fini.",
		"shapeNerdHard": "Reconnais chaque pays à sa silhouette et tape son nom : pas de propositions cette fois. Une petite faute de frappe passe, trois erreurs et c'est fini."
	},
	"faq": {
		"kicker": "Aide",
		"h1": "Questions fréquentes",
		"lead": "Le fonctionnement des parties, les comptes, les données, les pays inclus : voici ce qu'on nous demande le plus souvent.",
		"groupGame": "Jouer",
		"groupAccount": "Compte, scores et classement",
		"groupContent": "Le contenu du jeu",
		"contactLink": "Écrire un message",
		"aboutLink": "Lire la page À propos",
		"items": {
			"isFree": {
				"q": "Geo Nerd est-il payant ?",
				"a": "Non, Geo Nerd est entièrement gratuit et sans publicité. Un soutien à son développement reste possible, de façon facultative, via le lien « Buy me a coffee » en bas de page."
			},
			"howGamesWork": {
				"q": "Comment se déroule une partie ?",
				"a": "La plupart des modes se jouent à vies : 3 cœurs au départ, un cœur en moins à chaque erreur, la partie s'arrête à la troisième. Les modes Speed Run remplacent les vies par un chrono de 60 secondes, chaque erreur retirant 2 secondes."
			},
			"typos": {
				"q": "Les fautes de frappe sont-elles acceptées ?",
				"a": "Oui, dans les modes où le nom se tape au clavier : une lettre oubliée, une lettre en trop ou deux lettres inversées passent sans problème. En revanche, deux pays dont les noms se ressemblent de trop près ne sont jamais validés l'un pour l'autre."
			},
			"resume": {
				"q": "Que se passe-t-il si je quitte une partie en cours ?",
				"a": "Elle reprend là où elle s'est arrêtée. Les vies, les erreurs et le chrono sont enregistrés au fil de la partie : recharger la page ou revenir plus tard ne remet rien à zéro."
			},
			"dailyChallengeFaq": {
				"q": "Comment fonctionne le Défi du jour ?",
				"a": "20 questions identiques pour tout le monde chaque jour, un seul essai autorisé. Le résultat se partage sous forme de grille façon Wordle."
			},
			"mobile": {
				"q": "Geo Nerd fonctionne-t-il sur mobile ?",
				"a": "Oui, tous les modes de jeu (y compris la carte interactive) sont jouables au doigt sur mobile et tablette."
			},
			"sound": {
				"q": "Peut-on couper le son ?",
				"a": "Oui, avec l'icône haut-parleur en haut de page, et le choix est mémorisé. Les sons sont générés par le navigateur : il n'y a aucun fichier audio à télécharger."
			},
			"accountRequired": {
				"q": "Faut-il un compte pour jouer ?",
				"a": "Non. Sans compte, la progression et les meilleurs scores sont sauvegardés dans le navigateur. Créer un compte permet en plus de les retrouver sur un autre appareil, et d'apparaître dans le classement mondial."
			},
			"dataCollected": {
				"q": "Quelles données Geo Nerd collecte-t-il ?",
				"a": "Sans compte : aucune, tout reste dans le navigateur. Avec un compte : l'email, le pseudo, le mot de passe (jamais stocké en clair) et les scores, uniquement pour faire fonctionner la synchronisation. Le détail est dans les <a href=\"/mentions-legales\">mentions légales</a>."
			},
			"leaderboardRanking": {
				"q": "Comment fonctionne le classement ?",
				"a": "Chaque mode a son propre <a href=\"/leaderboard\">classement</a>, basé sur le meilleur score. À score égal, le nombre d'erreurs puis le temps départagent. Un classement général réunit les modes en un score sur 1000, où les versions difficiles comptent double."
			},
			"countryList": {
				"q": "Quels pays sont inclus dans le jeu ?",
				"a": "Les 193 États membres de l'ONU, tous consultables dans l'<a href=\"/pays/\">annuaire des pays</a>."
			},
			"languages": {
				"q": "Dans quelles langues Geo Nerd est-il disponible ?",
				"a": "En français et en anglais. La langue se change à tout moment via le sélecteur dans le menu."
			},
			"training": {
				"q": "Peut-on s'entraîner sans être noté ?",
				"a": "Oui. La <a href=\"/training-map\">carte du monde interactive</a> permet de cliquer sur n'importe quel pays pour voir son nom, son drapeau et sa capitale, sans vies ni chrono. L'<a href=\"/pays/\">annuaire des pays</a> réunit les 193 fiches."
			},
			"feedback": {
				"q": "Comment signaler un bug ou proposer une idée ?",
				"a": "Par email, à <a href=\"mailto:contact@geo-nerd.com\">contact@geo-nerd.com</a>. Bug, suggestion, drapeau ou capitale qui semble faux, faute de traduction : chaque message est lu."
			}
		}
	},
	"legal": {
		"h1": "Mentions légales & politique de confidentialité",
		"updated": "Dernière mise à jour : octobre 2026",
		"editorTitle": "Éditeur du site",
		"editorBody": "<p>Geo Nerd est édité à titre non professionnel par Florian LUCAS. Conformément à l'article 6-III de la loi n° 2004-575 du 21 juin 2004 (LCEN), l'éditeur étant une personne physique n'agissant pas à titre professionnel, son adresse personnelle n'est pas publiée mais reste communicable à toute autorité judiciaire ou administrative qui en ferait la demande.</p><p>Contact : <a href=\"mailto:contact@geo-nerd.com\">contact@geo-nerd.com</a></p>",
		"hostTitle": "Hébergement",
		"hostBody": "<p>Le site est hébergé par OVH SAS, 2 rue Kellermann, 59100 Roubaix, France (RCS Lille Métropole 424 761 419 00045), <a href=\"https://www.ovh.com\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">ovh.com</a>.</p>",
		"ipTitle": "Propriété intellectuelle",
		"ipBody": "<p>Le code, les textes, les visuels et le design de Geo Nerd sont la propriété de Florian LUCAS, sauf mention contraire. Les données factuelles des fiches pays (population, superficie, monnaie…) proviennent de Wikidata, publiées sous licence CC0 (domaine public). Les contours des petits pays sur les silhouettes et les cartes des fiches viennent de Natural Earth (domaine public), et, pour les plus petits, de geoBoundaries : contours issus d'OpenStreetMap (© contributeurs OpenStreetMap, licence ODbL, <a href=\"https://www.openstreetmap.org/copyright\" target=\"_blank\" rel=\"noopener noreferrer\">openstreetmap.org/copyright</a>) ou de Wikimedia Commons (CC BY 2.5 ou domaine public).</p>",
		"privacyTitle": "Politique de confidentialité",
		"privacyIntro": "<p>Cette section explique quelles données sont traitées lors de l'utilisation de Geo Nerd, conformément au Règlement Général sur la Protection des Données (RGPD).</p>",
		"dataNoAccountTitle": "Sans compte",
		"dataNoAccountBody": "<p>La progression, les meilleurs scores et les préférences (son, langue) sont stockés uniquement dans le stockage local du navigateur (localStorage), sur l'appareil utilisé. Ces données peuvent être effacées à tout moment depuis les réglages du navigateur.</p><p>Pour compter les joueurs et savoir combien reviennent, un identifiant aléatoire, sans lien avec ton identité, est créé dans le navigateur. Il est envoyé au serveur à ta première partie terminée, puis au plus une fois par jour de visite, avec la date. À la fin du Défi du jour, ton score part avec ce même identifiant pour t'indiquer ta place parmi les joueurs du jour. Chaque partie terminée est aussi comptée avec lui (le jeu, le score et le jour), pour savoir quels jeux sont joués. Ces données ne servent qu'à des statistiques d'ensemble, ne sont jamais croisées avec d'autres et ne permettent pas de te retrouver. Les scores du jour sont supprimés au bout de 60 jours, les parties comptées au bout de 13 mois, l'identifiant au bout de 25 mois sans visite.</p>",
		"dataAccountTitle": "Avec un compte",
		"dataAccountBody": "<p>La création d'un compte est facultative et sert à retrouver la progression sur plusieurs appareils. Elle implique le stockage sur le serveur (hébergé par OVH, en France) de l'email, du pseudo, du mot de passe (hashé, jamais stocké ni consulté en clair), des scores, de la langue et du fuseau horaire. Ces données ne sont ni revendues ni partagées avec des tiers, et ne servent à aucun profilage publicitaire. Elles sont conservées tant que le compte existe.</p><p>Ton e-mail sert aussi, quelques fois par an au plus, à t'annoncer les nouveautés du jeu. La base légale est l'intérêt légitime de Geo Nerd à informer ses joueurs des évolutions du service. Tu peux t'y opposer à tout moment, depuis ton profil ou en un clic depuis chacun de ces e-mails, sans effet sur tes rappels ; la date de ton opposition est conservée.</p><p>Depuis ton profil, tu peux supprimer ton compte définitivement, à tout moment.</p>",
		"cookiesTitle": "Cookies",
		"cookiesBody": "<p>Un compte créé pose un unique cookie de session (technique, nécessaire à la connexion, non lu par des tiers). Geo Nerd peut également utiliser Google Analytics pour mesurer l'audience du site (pages consultées, provenance du trafic), sans profilage publicitaire ni revente de données ; voir la <a href=\"https://policies.google.com/privacy\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">politique de confidentialité de Google</a>.</p>",
		"rightsTitle": "Droits",
		"rightsBody": "<p>Conformément au RGPD, chacun dispose d'un droit d'accès, de rectification, de suppression et de portabilité des données le concernant, et peut retirer son consentement aux rappels ou s'opposer aux nouveautés à tout moment. La suppression du compte, les rappels et les nouveautés se gèrent directement depuis ton profil, et la désinscription depuis le lien des e-mails. Pour toute autre demande, y compris une copie de tes données : <a href=\"mailto:contact@geo-nerd.com\">contact@geo-nerd.com</a>. Une réclamation peut aussi être introduite auprès de la CNIL (<a href=\"https://www.cnil.fr\" target=\"_blank\" rel=\"noopener noreferrer nofollow\">cnil.fr</a>).</p>",
		"remindersTitle": "Rappels et notifications",
		"remindersBody": "<p>Les rappels du Défi du jour ne partent que si tu les as demandés : case décochée par défaut à l'inscription, interrupteurs dans ton profil. La base légale est ton consentement, dont la date est conservée comme preuve, tout comme celle de son retrait.</p><p><strong>Par e-mail</strong> (avec un compte) : au plus un e-mail par jour, à l'heure que tu choisis, seulement si tu n'as pas encore joué, et une pause automatique après 7 rappels restés sans partie. Les e-mails sont envoyés par le prestataire Resend (resend.com), qui ne les utilise que pour cet envoi. Chaque rappel contient un lien pour se désinscrire en un clic, sans se connecter.</p><p><strong>Par notification</strong> (avec ou sans compte) : ton navigateur fournit une adresse d'abonnement propre à son service de notifications (Google, Mozilla ou Apple), conservée avec ta langue, ton fuseau et l'heure choisie. Elle est supprimée dès que tu coupes les notifications ou que ton navigateur la déclare expirée.</p>",
		"labBody": "<p>Dans les jeux du Lab, chaque partie terminée est comptée avec le même identifiant aléatoire, et la note ou le commentaire que tu choisis de laisser sont conservés pour améliorer ces jeux : 13 mois pour les parties, 2 ans pour les avis. Évite d'écrire des informations personnelles dans un commentaire.</p>"
	},
	"nudge": {
		"recordTitle": "Nouveau record !",
		"recordBody": "Il n'existe que dans ce navigateur. Crée un compte gratuit pour le garder sur tous tes appareils et apparaître au classement.",
		"streakTitle": "Ta série compte",
		"streakBody": "{n} jours d'affilée, enregistrés seulement dans ce navigateur. Crée un compte gratuit pour ne pas les perdre.",
		"cta": "Créer mon compte"
	},
	"daily": {
		"themeToday": "Aujourd'hui : {theme}",
		"theme": {
			"flags": "drapeaux",
			"capitals": "capitales",
			"mix": "drapeaux et capitales"
		},
		"capitalQuestion": "Quelle est sa capitale ?",
		"typeCapital": "Nom de la capitale",
		"percentile": {
			"few": "Tu fais partie des premiers à jouer aujourd'hui : reviens plus tard pour te comparer aux autres.",
			"perfect": "Sans faute ! Seuls {pct} % des {total} joueurs du jour ont fait aussi bien.",
			"better": "Mieux que {pct} % des {total} joueurs du jour."
		},
		"jokerUsed": "Joker utilisé : le jour manqué ne casse pas ta série.",
		"jokerReady": "Joker prêt : un jour manqué ne cassera pas ta série.",
		"jokerRecharge": "Joker de nouveau prêt dans {n} jours.",
		"historyTitle": "Tes défis",
		"historySummary": "{n} joués, {avg}/20 en moyenne",
		"nextIn": "Prochain défi dans",
		"newChallengeReady": "c'est l'heure, recharge la page !",
		"meanwhile": "En attendant :",
		"tryHard": "le défi Hard du jour",
		"tryClassic": "le défi Classic du jour",
		"remindMe": "Me rappeler le défi demain",
		"remindMeNote": "Une notification par jour au plus, seulement si tu n'as pas encore joué. Ça se coupe depuis ton profil.",
		"remindMeDone": "C'est noté : rappel vers {hour} les jours où tu n'as pas encore joué. Réglages dans ton profil.",
		"historySummaryOne": "1 joué, {avg}/20"
	},
	"unsubscribe": {
		"title": "Désinscription",
		"working": "Un instant…",
		"done": "C'est fait : {email} ne recevra plus de rappels du Défi du jour.",
		"undo": "Je me suis trompé, me réabonner",
		"undone": "Rappels réactivés pour {email}.",
		"invalid": "Ce lien de désinscription n'est plus valide. Tes rappels se règlent aussi depuis ton profil.",
		"error": "Le serveur ne répond pas pour l'instant. Réessaie dans un moment, ou écris à contact@geo-nerd.com.",
		"home": "Retour au jeu",
		"doneNews": "C'est fait : {email} ne recevra plus les nouveautés de Geo Nerd. Tes rappels du Défi du jour, si tu les as activés, ne changent pas.",
		"undoneNews": "Nouveautés réactivées pour {email}."
	},
	"reminders": {
		"title": "Rappels du Défi du jour",
		"intro": "Un petit mot les jours où tu n'as pas encore joué, jamais plus d'un par jour. Pause automatique après 7 rappels sans partie.",
		"email": "Par e-mail",
		"paused": "En pause après 7 rappels sans partie : réactive-les pour en recevoir de nouveau.",
		"emailNeedsAccount": "Les rappels par e-mail demandent un <a href=\"/inscription\">compte gratuit</a>.",
		"push": "Par notification sur cet appareil",
		"pushIos": "Sur iPhone, les notifications demandent d'installer Geo Nerd : touche Partager, puis « Sur l'écran d'accueil ».",
		"pushBlocked": "Les notifications de Geo Nerd sont bloquées dans ton navigateur : autorise-les dans ses réglages pour les activer ici.",
		"hour": "Heure du rappel",
		"legal": "Ton e-mail ne sert qu'à ton compte, à ces rappels et, quelques fois par an, aux nouveautés du jeu. Le détail est dans la <a href=\"/mentions-legales\">politique de confidentialité</a>.",
		"error": "Le réglage n'a pas pu être enregistré. Réessaie dans un moment.",
		"emailOn": "Rappels par e-mail activés. Un e-mail de confirmation vient de partir.",
		"emailOff": "Rappels par e-mail coupés.",
		"pushOn": "Notifications activées sur cet appareil.",
		"pushOff": "Notifications coupées sur cet appareil.",
		"hourSaved": "Heure du rappel enregistrée."
	},
	"privacy": {
		"title": "Mes données",
		"intro": "Supprime définitivement ton compte, avec ta progression en ligne et tes rappels.",
		"delete": "Supprimer mon compte",
		"deleteConfirm": "C'est définitif : ton compte, ta progression en ligne et tes rappels seront effacés. La progression enregistrée sur cet appareil reste. Confirme avec ton mot de passe.",
		"deleteCta": "Supprimer définitivement",
		"cancel": "Annuler",
		"wrongPassword": "Mot de passe incorrect."
	},
	"install": {
		"title": "Geo Nerd sur ton écran d'accueil",
		"body": "Le défi du jour à portée de pouce, en plein écran, comme une appli.",
		"iosBody": "Sur iPhone : touche Partager, puis « Sur l'écran d'accueil ». Tu pourras aussi y recevoir le rappel du défi.",
		"cta": "Installer",
		"later": "Plus tard"
	},
	"passport": {
		"title": "Mon passeport",
		"subtitle": "Trois tampons par pays : son drapeau, sa capitale et sa place sur la carte. Combien de pays as-tu complétés ?",
		"profileTeaser": "Les pays dont tu connais le drapeau, la capitale et la place sur la carte.",
		"completeLabel": "pays complets",
		"flags": "Drapeaux",
		"capitals": "Capitales",
		"maps": "Carte",
		"flag": "Drapeau",
		"capital": "Capitale",
		"map": "Carte",
		"notOnMap": "Absent de la carte jouable",
		"allZones": "Tous",
		"onlyMissing": "À compléter seulement",
		"allDone": "Rien à compléter ici : bravo !",
		"howTitle": "Gagner des tampons",
		"howFlag": "Drapeau : reconnais-le dans <a href=\"/flag-nerd-classic\">Flag Nerd</a> ou le Défi du jour.",
		"howCapital": "Capitale : trouve-la dans <a href=\"/capital-nerd-classic\">Capital Nerd</a> ou le Défi du jour les jours de capitales.",
		"howMap": "Carte : situe le pays dans <a href=\"/map-nerd-classic\">Map Nerd</a> (les micro-États n'y figurent pas, ils se complètent sans).",
		"earned": "obtenu",
		"missing": "à gagner"
	},
	"zones": {
		"label": "Zone de jeu",
		"trainingNote": "Partie d'entraînement : seule la partie Monde compte au classement."
	},
	"review": {
		"title": "Révision",
		"subtitle": "Tes erreurs reviennent au bon moment : tout de suite, puis 1, 3, 7 et 16 jours plus tard, jusqu'à ce qu'elles soient acquises.",
		"statDue": "à revoir",
		"statLearning": "en cours",
		"statMastered": "acquises",
		"start": "Réviser ({n})",
		"emptyDeck": "Rien à réviser pour l'instant : chaque erreur sur un drapeau ou une capitale, dans n'importe quel jeu, viendra s'ajouter ici.",
		"nothingDue": "Rien à revoir aujourd'hui. Prochaine révision : {date}.",
		"allMastered": "Tout est acquis : il ne reste rien à réviser.",
		"flagQuestion": "De quel pays est ce drapeau ?",
		"itWas": "C'était : {answer}",
		"retained": "retenues",
		"moreDue": "Encore {n} à revoir aujourd'hui.",
		"nextOn": "Prochaine révision : {date}.",
		"backToOverview": "Continuer"
	},
	"lab": {
		"shapeNerd": "Shape Nerd",
		"borderNerd": "Border Nerd",
		"dataError": "Les données de ce jeu n'ont pas pu être chargées. Recharge la page dans un moment.",
		"shapeQuestion": "Quel est ce pays ?",
		"shapePitch": "Reconnais un pays à sa forme",
		"borderQuestion": "Cite tous ses pays voisins",
		"borderPlaceholder": "Un pays voisin",
		"borderCount": "{found}/{n} voisins trouvés",
		"borderUnknown": "Pays non reconnu : vérifie l'orthographe.",
		"borderAlready": "{name} est déjà trouvé.",
		"borderWrong": "{name} n'est pas un voisin.",
		"borderSkip": "Je passe",
		"borderSkipped": "Passé",
		"borderPitch": "Cite tous les pays voisins",
		"challenge": {
			"title": "Défi un ami",
			"short": "10 questions, un lien à envoyer",
			"pitch": "Choisis un thème, réponds à 10 questions, puis envoie le lien : ton ami jouera exactement les mêmes et verra qui l'emporte.",
			"theme": {
				"flags": "Drapeaux",
				"capitals": "Capitales",
				"borders": "Frontières",
				"shapes": "Silhouettes",
				"all": "Tous les modes"
			},
			"themeLine": "Thème : {theme}",
			"invite": "{name} te défie !",
			"someone": "Quelqu'un",
			"theirResult": "Son score : {score}/10 en {time}.",
			"accept": "Relever le défi",
			"win": "Tu bats {name} !",
			"lose": "{name} garde l'avantage cette fois.",
			"tie": "Égalité parfaite avec {name} !",
			"yourName": "Ton prénom ou pseudo (vu par ton ami)",
			"send": "Défier un ami",
			"sendBack": "Renvoyer le défi",
			"new": "Nouveau défi",
			"shareText": "J'ai fait {score}/10 à ce défi Geo Nerd. À toi de jouer :",
			"themeName": {
				"flags": "drapeaux",
				"capitals": "capitales",
				"borders": "frontières",
				"shapes": "silhouettes",
				"all": "tous les modes",
				"mix": "drapeaux et capitales"
			},
			"borderQuestion": "Lequel de ces pays est son voisin ?",
			"loading": "Préparation du défi…",
			"loadError": "Impossible de charger ce thème. Vérifie ta connexion et réessaie.",
			"retry": "Réessayer"
		},
		"rating": {
			"title": "Tu as aimé ce mode ?",
			"again": "Ta note pour ce mode (tu peux la changer)",
			"placeholder": "Un mot pour nous aider à l'améliorer (facultatif)",
			"send": "Envoyer",
			"thanks": "Merci pour ta note !",
			"thanksComment": "Merci, ton avis nous aide à améliorer le Lab !"
		},
		"play": "Jouer",
		"shapeNerdHard": "Shape Nerd Hard",
		"shapeHardPitch": "La silhouette, sans propositions : tape le nom du pays"
	},
	"newsEmail": {
		"title": "Nouveautés",
		"intro": "Un e-mail quand Geo Nerd change vraiment (nouveaux jeux, nouveaux modes), quelques fois par an au plus.",
		"toggle": "Nouveautés de Geo Nerd par e-mail",
		"on": "Tu recevras les prochaines nouveautés.",
		"off": "C'est noté : plus d'e-mail de nouveautés. Tes rappels ne changent pas."
	}
}
